import { render, staticRenderFns } from "./ProgramContracts.vue?vue&type=template&id=1f15e85c&"
import script from "./ProgramContracts.vue?vue&type=script&lang=js&"
export * from "./ProgramContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports